// import classNames from "classnames";
// import { useTranslation } from "react-i18next";
// import Button from "src/components-v2/Button";
// import IlusCS from "src/assets/images/common/ilus-call-support.png";

function DepositStatusInactive(): null {
  // const { onClickActivateDeposit, className } = props;
  // const { t } = useTranslation("deposit");

  return null;
  // hide activate deposit
  // return (
  //   <div
  //     className={classNames(
  //       "u-bg-main-background u-px-4 u-py-2 md:u-px-8 2xl:u-px-12",
  //       "u-flex u-justify-center u-items-center u-gap-5",
  //       className
  //     )}
  //   >
  //     <img src={IlusCS} width={38} />
  //     <p className="u-mb-0">
  //       <Trans t={t} i18nKey={"overview.banner-deposit-auto-withdrawal.inactive.description"}>
  //         <span className="u-font-medium" />
  //       </Trans>
  //     </p>
  //     <Button onClick={onClickActivateDeposit} variant="secondary">
  //       {t("overview.banner-deposit-auto-withdrawal.inactive.activate-button")}
  //     </Button>
  //   </div>
  // );
}

export default DepositStatusInactive;
